import { createContext } from "react";

export const PlannerContext = createContext({
  // UI state
  selectedTool: "templateSelect",
  setSelectedTool: () => {},
  selectedBlockId: null,
  setSelectedBlockId: () => {},
  selectBlock: () => {},
  activeTime: null,
  setActiveTime: () => {},
  toolPanelOpen: false,
  setToolPanelOpen: () => {},
  openToolPanel: () => {},
  closeToolPanel: () => {},

  // Loading state
  isLoading: true,
  isNavigating: false,
  isSaving: false,

  // Date navigation
  currentDate: "",
  setCurrentDate: () => {},
  goToNextDay: () => {},
  goToPreviousDay: () => {},

  // Data
  blocks: {},
  sortedBlocks: [],
  activities: [],
  tasks: [],

  // Block operations
  addBlock: () => {},
  updateBlock: () => {},
  deleteBlock: () => {},

  // Template operations
  currentTemplate: null,
  availableTemplates: {},
  loadTemplate: () => {},
  saveAsTemplate: () => {},
  updateTemplate: () => {},
  deleteTemplate: () => {},
  clearDay: () => {},

  // Day configuration
  day: {
    startTime: "08:00",
    endTime: "22:00",
    timeInterval: 30,
    setStartTime: () => {},
    setEndTime: () => {},
    setTimeInterval: () => {},
  },

  // Utilities
  timeToMinutes: () => 0,
  minutesToTime: () => "00:00",
  snapToInterval: () => "00:00",

  // Dev utilities (for testing time-based features)
  mockTime: null, // Format: "HH:MM" or null for real time
  setMockTime: () => {},
  getCurrentTime: () => "00:00", // Returns current time (real or mocked)
});
